/**
 * Zoom controls (docs/06-UI-SPEC.md §6.6), floating bottom-right.
 *
 * Clicking the percentage returns to 100%. Panning, Ctrl+wheel, pinch and Fit to
 * Content arrive at step 2.5.
 */

import { useBoardStore } from '../../board/store.js';

const BUTTON =
  'flex h-touch w-touch items-center justify-center rounded-md text-lg text-text-primary transition duration-fast ease-out hover:bg-surface-hover';

export function ZoomControls() {
  const zoom = useBoardStore((state) => state.viewport.zoom);
  const zoomIn = useBoardStore((state) => state.zoomIn);
  const zoomOut = useBoardStore((state) => state.zoomOut);
  const resetZoom = useBoardStore((state) => state.resetZoom);
  const fitToContent = useBoardStore((state) => state.fitToContent);

  return (
    <div className="absolute bottom-6 right-6 flex items-center gap-1 rounded-md border border-border bg-surface px-2 shadow-md">
      <button type="button" aria-label="Zoom out" className={BUTTON} onClick={zoomOut}>
        −
      </button>
      <button
        type="button"
        aria-label="Reset zoom to 100%"
        onClick={resetZoom}
        className="tabular h-touch min-w-[64px] rounded-md px-2 text-base text-text-primary transition duration-fast ease-out hover:bg-surface-hover"
      >
        {Math.round(zoom * 100)}%
      </button>
      <button type="button" aria-label="Zoom in" className={BUTTON} onClick={zoomIn}>
        +
      </button>
      <button
        type="button"
        aria-label="Fit to content"
        title="Fit to content"
        className={BUTTON}
        onClick={fitToContent}
      >
        ⛶
      </button>
    </div>
  );
}
